class A11y {
  static get theme() {
    return A11y.get('theme');
  }

  static set theme(value) {
    const val = typeof value === 'string' ? value : '';
    document.body.setAttribute('data-theme', val);
    return A11y.set('theme', val);
  }

  static get minFontSize() {
    return -1;
  }

  static get maxFontSize() {
    return 1;
  }

  static get fontSize() {
    return +A11y.get('font-size') || 0;
  }

  static set fontSize(value) {
    const n = +value || 0;

    if (n < A11y.minFontSize || n > A11y.maxFontSize) {
      return A11y.set('font-size', A11y.fontSize);
    }

    document.body.setAttribute('data-font-size', n);
    return A11y.set('font-size', n);
  }

  static get prefix() {
    return '@a11y';
  }

  static get(key) {
    return localStorage.getItem(`${A11y.prefix}/${key}`);
  }

  static set(key, val) {
    return localStorage.setItem(`${A11y.prefix}/${key}`, val);
  }
}

const btnZoom = document.querySelector(".a11y-controls__zoom");
document.body.setAttribute('data-zoom-size', '');

if (localStorage.getItem("zoomEcrie") !== "" && localStorage.getItem("zoomEcrie") !== null) {
  document.body.setAttribute('data-zoom-size', localStorage.getItem("zoomEcrie"));
  document.querySelectorAll(".a11y-controls__zoom svg path")[1].setAttribute("d", "M13,9H7a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z");
};

if(btnZoom) {
  btnZoom.addEventListener("click", () =>{
    if (document.body.getAttribute('data-zoom-size') === "") {
      document.body.setAttribute('data-zoom-size', "1.4");
      localStorage.setItem("zoomEcrie", "1.4");
      document.querySelectorAll(".a11y-controls__zoom svg path")[1].setAttribute("d", "M13,9H7a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z");
    } else {
      document.body.setAttribute('data-zoom-size', "");
      localStorage.setItem("zoomEcrie", "");
      document.querySelectorAll(".a11y-controls__zoom svg path")[1].setAttribute("d", "M13,9H11V7A1,1,0,0,0,9,7V9H7a1,1,0,0,0,0,2H9v2a1,1,0,0,0,2,0V11h2a1,1,0,0,0,0-2Z");
    }
  })
}

A11y.theme = localStorage.getItem(`${A11y.prefix}/theme`);

A11y.fontSize = localStorage.getItem(`${A11y.prefix}/font-size`);

window.A11y = A11y;

export default A11y;
